import React from "react";
import type { FileNode } from "@/notes/types";

interface TreeViewContextType {
	activeNote: FileNode | null;
	renamingId: string | null;
	expandedIds: Set<string>;
	toggleExpanded: (id: string) => void;
	setRenamingId: (id: string | null) => void;
	onSelect: (node: FileNode | null) => void;
	onRename: (id: string, newTitle: string, content?: string | null) => void;
	onDelete: (id: string) => void;
}

// We provide a default value, but it will be overridden by the Provider.
// The non-null assertion (!) is safe here because we will always use this
// context within a Provider that supplies a valid value.
export const TreeViewContext = React.createContext<TreeViewContextType>({
	activeNote: null,
	renamingId: null,
	expandedIds: new Set(),
	toggleExpanded: () => {},
	setRenamingId: () => {},
	onSelect: () => {},
	onRename: () => {},
	onDelete: () => {},
});
